import { jsx as _jsx } from "react/jsx-runtime";
import { CampaignEvent, CharacterEvent, GalaxyEvent, useAppContext, } from '@datapad/data-model';
import { CharacterImageVariant, ImageContainerShape, renderCampaignImage, renderCharacterImage, renderFirstFactionEmblem, } from '@datapad/common-controls';
import { assert } from '@datapad/utilities';
import { Groups, Person, Public } from '@mui/icons-material';
import { TimelineDot as MuiTimelineDot } from '@mui/lab';
import { Box } from '@mui/material';
import { Tree } from 'fluid-framework';
const ICON_SIZE_PIXELS = 40;
export function TimelineDot(props) {
    const { event, isSelected, onClick } = props;
    const icon = _jsx(EventIcon, { event: event });
    return (_jsx(Box, { onClick: (clickEvent) => {
            onClick();
            clickEvent.stopPropagation();
        }, sx: { cursor: 'pointer' }, children: _jsx(MuiTimelineDot, { variant: "outlined", color: isSelected ? 'primary' : 'grey', children: _jsx(Box, { sx: {
                    height: ICON_SIZE_PIXELS,
                    width: ICON_SIZE_PIXELS,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    '& img': {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    },
                }, children: icon }) }) }));
}
function EventIcon({ event }) {
    const imageOptions = {
        maxHeightInPixels: ICON_SIZE_PIXELS,
        maxWidthInPixels: ICON_SIZE_PIXELS,
        containerShape: ImageContainerShape.Rectangle,
    };
    const appContext = useAppContext();
    if (Tree.is(event, GalaxyEvent)) {
        if (event.involvedFactions.length > 0) {
            return renderFirstFactionEmblem([...event.involvedFactions], imageOptions);
        }
        return _jsx(Public, { sx: { fontSize: ICON_SIZE_PIXELS } });
    }
    if (Tree.is(event, CampaignEvent)) {
        const campaign = appContext.getCampaign(event.campaign);
        const campaignImage = renderCampaignImage(campaign, imageOptions);
        if (campaignImage !== undefined) {
            return campaignImage;
        }
        return _jsx(Groups, { sx: { fontSize: ICON_SIZE_PIXELS } });
    }
    assert(Tree.is(event, CharacterEvent), 'Expected character event.');
    if (event.characters.length > 0) {
        const character = appContext.getCharacter(event.characters[0]);
        return renderCharacterImage(character, {
            ...imageOptions,
            variant: CharacterImageVariant.Profile,
        });
    }
    return _jsx(Person, { sx: { fontSize: ICON_SIZE_PIXELS } });
}
//# sourceMappingURL=TimelineDot.js.map